var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.fixedRectangle,style:(_vm.containerStyle),on:{"click":_vm.handleClick}},[_c('img',{class:_vm.$style.backgroundImage,style:(_vm.backgroundStyle),attrs:{"src":_vm.backgroundImageUrl}})])}
var staticRenderFns = []

export { render, staticRenderFns }